import { ROOT_URL, saveError } from 'Api';
import service from 'Api/service';
import { setErrors } from './dashboardActionCreators';
import {
  UNASSIGN_TRUCK_REQUEST,
  ASSIGN_TRUCK_REQUEST,
  FETCH_RENTAL_TRANSPORT_FAILURE,
  FETCH_RENTAL_TRANSPORT_SUCCESS,
} from 'Constants/redux';
import {
  openLoadingSpinner,
  closeLoadingSpinner,
} from './LoadingSpinnerActions';

export const assignTruck = (
  id,
  rental_transport_id,
  truck_id,
  delivery_date,
  fromRoutingTab = false,
  relationship_id = null,
  additionalTrucks = [],
  assignItemsToLoadList = false,
) => {
  return (dispatch, getState) => {
    dispatch({
      type: ASSIGN_TRUCK_REQUEST,
    });
    dispatch(openLoadingSpinner('Assigning truck...'));
    service
      .post(
        `${ROOT_URL}/rental_transports/${rental_transport_id}/assign_truck`,
        {
          rental_transport_id,
          truck_id,
          delivery_date,
          relationship_id,
          additional_trucks: additionalTrucks,
          fromRoutingTab,
          assign_items_to_loadlist: assignItemsToLoadList,
        }
      )
      .then((response) => {
        dispatch(closeLoadingSpinner());
        return dispatch({
          response,
          type: FETCH_RENTAL_TRANSPORT_SUCCESS,
        });
      })
      .catch((error) => {
        console.log(error);
        dispatch(closeLoadingSpinner());
        saveError(error, getState());
        dispatch({
          error,
          type: FETCH_RENTAL_TRANSPORT_FAILURE,
        });
        dispatch(setErrors(error.response.data));
      });
  };
};

export const unassignTruck = (id, rental_transport_id, relationship_id, truck_id) => {
  return (dispatch, getState) => {
    dispatch({
      type: UNASSIGN_TRUCK_REQUEST,
    });
    dispatch(openLoadingSpinner('Unassigning truck...'));
    // FIXME: change to GraphQL call to UnassignTrucksFromRentalTransport mutation
    service
      .post(
        `${ROOT_URL}/rental_transports/${rental_transport_id}/unassign_truck`,
        {
          rental_transport_id,
          relationship_id,
          truck_id,
        }
      )
      .then((response) => {
        dispatch(closeLoadingSpinner());
        return dispatch({
          response,
          type: FETCH_RENTAL_TRANSPORT_SUCCESS,
        });
      })
      .catch((error) => {
        console.log(error);
        dispatch(closeLoadingSpinner());
        saveError(error, getState());
        dispatch({
          error,
          type: FETCH_RENTAL_TRANSPORT_FAILURE,
        });
        dispatch(setErrors(error.response.data));
      });
  };
};
